import { base, getEnv } from '../../utils';

export const getFollows = async (userId) => {
  try {
    const { SITE_TYPE } = getEnv();
    const url = `/v1/${SITE_TYPE}/users/${userId}/follows`;

    const response = await base.get(url);
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};
